
// vue
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Progress',
  props: {
    completeVal: {
      type: Number,
      required: true,
    },
    showPercentage: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
});
